import { IInvoicesParams } from "../types";
import { useQuery } from "@tanstack/react-query";
import { QUERY_CONSTANTS } from "../queryKeys";
import { IInvoiceForTable } from "../../models/Invoice";
import { InvoiceService } from "../../services/invoice.service";

export const useGetAllInvoicesQuery = (data: IInvoicesParams) => {
  return useQuery<{ data: IInvoiceForTable[]; totalCount: number }, Error>({
    queryKey: [QUERY_CONSTANTS.GET_ALL_INVOICES, data],
    queryFn: () =>
      InvoiceService.getInvoices(
        data.currentPage,

        data.pageSize
      ).then((res) => res.data),
  });
};
